module.exports = __webpack_public_path__ + "img/3.5523eb9b.png";